const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

const parkWarehouseRouter = {
  path: '/park/warehouse',
  component: index,
  children: [
    {
      path: 'projectList',
      name: 'projectList',
      component: () => import('@/pages/park/warehouse/project/projectList/index.vue'),
      meta: {
        keepAlive: true,
        title: '立项列表',
      },
    },
    {
      path: 'projectCreates',
      name: 'projectCreates',
      component: () => import('@/pages/park/warehouse/project/projectDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '立项新增',
      },
    },
    {
      path: 'projectDetails',
      name: 'projectDetails',
      component: () => import('@/pages/park/warehouse/project/projectDetail/index.vue'),
      meta: {
        keepAlive: true,
        title: '立项详情',
      },
    },
    {
      path: 'contractList',
      name: 'contractList',
      component: () => import('@/pages/park/warehouse/contract/contractList/index.vue'),
      meta: {
        keepAlive: true,
        title: '仓储合同列表',
      },
    },
    {
      path: 'contractMaintainance',
      name: 'contractMaintainance',
      component: () => import('@/pages/park/warehouse/contract/contractMaintainance/index.vue'),
      meta: {
        keepAlive: true,
        title: '仓储合同维护',
      },
    },
    {
      path: 'contractDetail',
      name: 'contractDetail',
      component: () => import('@/pages/park/warehouse/contract/contractMaintainance/index.vue'),
      meta: {
        keepAlive: true,
        title: '仓储合同详情',
      },
    },
    {
      path: 'contractClose',
      name: 'contractClose',
      component: () => import('@/pages/park/warehouse/contract/contractMaintainance/index.vue'),
      meta: {
        keepAlive: true,
        title: '仓储合同关闭',
      },
    },
    {
      path: 'contractApprove',
      name: 'contractApprove',
      component: () => import('@/pages/park/warehouse/contract/contractMaintainance/index.vue'),
      meta: {
        keepAlive: true,
        title: '仓储合同审批',
      },
    },
    {
      path: 'contractRenew',
      name: 'contractRenew',
      component: () => import('@/pages/park/warehouse/contract/contractMaintainance/index.vue'),
      meta: {
        keepAlive: true,
        title: '仓储合同续签',
      },
    },
    {
      path: 'contractChange',
      name: 'contractChange',
      component: () => import('@/pages/park/warehouse/contract/contractMaintainance/index.vue'),
      meta: {
        keepAlive: true,
        title: '仓储合同信息变更',
      },
    },
    {
      path: 'detailAccount',
      name: 'detailAccount',
      component: () => import('@/pages/park/warehouse/reportManagement/detailAccount.vue'),
      meta: {
        keepAlive: true,
        title: '应收账款明细表',
      },
    },
    {
      path: 'summarizing',
      name: 'summarizing',
      component: () => import('@/pages/park/warehouse/reportManagement/summarizing.vue'),
      meta: {
        keepAlive: true,
        title: '应收账款汇总表',
      },
    },
  ],
};

export default parkWarehouseRouter;
